import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0252384e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl" }, "Фильтры", -1))
const _hoisted_2 = { class: "CashOnDeliveriesFilters__row" }
const _hoisted_3 = { class: "CashOnDeliveriesFilters__actions" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"])),
    class: "CashOnDeliveriesFilters"
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_the_select, {
        class: "mt-2",
        "can-deselect": "",
        value: _ctx.state.companyId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.companyId) = $event)),
        placeholder: "Компания",
        loading: _ctx.data_state.companies.is_loading,
        options: _ctx.data_state.companies.list,
        failed: _ctx.data_state.companies.is_failed,
        "error-text": "При получении списка компаний произошла ошибка",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        "infinite-scroll": "",
        "search-without-refresh": "",
        onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
        onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1)))
      }, null, 8, ["value", "loading", "options", "failed"]),
      _createVNode(_component_the_select, {
        placeholder: "Статус",
        value: _ctx.state.statusIds,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.statusIds) = $event)),
        loading: _ctx.data_state.statuses.is_loading,
        failed: _ctx.data_state.statuses.is_failed,
        "error-text": "При получении списка произошла ошибка",
        options: _ctx.data_state.statuses.list,
        "infinite-scroll": "",
        multiselect: "",
        onRefresh: _ctx.loadStatuses,
        class: "mt-2",
        "can-deselect": ""
      }, null, 8, ["value", "loading", "failed", "options", "onRefresh"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.startTime,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.startTime) = $event)),
        type: "date",
        placeholder: "Дата от"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.endTime,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.endTime) = $event)),
        type: "date",
        placeholder: "Дата до"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.invoiceNumber,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.invoiceNumber) = $event)),
        placeholder: "Номер накладной"
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_the_button, {
        class: "second text small mr-3",
        disabled: _ctx.loading,
        onClick: _ctx.reset
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_the_button, {
        class: "primary text small",
        loading: _ctx.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(" Сформировать отчет ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}